import { ChevronLeft, ChevronRight, CircleChevronLeft, CircleChevronRight } from 'lucide-react';
import "./Pagination.css"
function buildPageItems(total, current, max = 7) {
  if (total <= max) return Array.from({ length: total }, (_, i) => i + 1);

  const items = [];
  const showLeft = current > 3;
  const showRight = current < total - 2;

  items.push(1);
  if (showLeft) items.push('…');

  const start = Math.max(2, current - 1);
  const end = Math.min(total - 1, current + 1);
  for (let p = start; p <= end; p++) items.push(p);

  if (showRight) items.push('…');
  items.push(total);

  return items;
}

export default function Pagination({ page, pages, onChange }) {
  const items = buildPageItems(pages, page);

  return (
    <div className="pg-pagination-container">
    <nav className="pg-wrap" aria-label="Pagination">
      <button
        className="pg-btn prev"
        onClick={() => onChange(Math.max(1, page - 1))}
        disabled={page === 1}
      >
        <CircleChevronLeft size={18}  style={{ color: 'var(--foreground)' }} />
        Previous
      </button>

      <ul className="pg-list">
        {items.map((it, idx) =>
          it === '…' ? (
            <li key={`e-${idx}`} className="pg-ellipsis">…</li>
          ) : (
            <li key={it}>
              <button
                className={`pg-page ${page === it ? 'active' : ''}`}
                onClick={() => onChange(it)}
                aria-current={page === it ? 'page' : undefined}
              >
                {it}
              </button>
            </li>
          )
        )}
      </ul>

      <button
        className="pg-btn next"
        onClick={() => onChange(Math.min(pages, page + 1))}
        disabled={page === pages || pages === 0}
      >
        Next
        <CircleChevronRight size={18} style={{ color: 'var(--foreground)' }} />
      </button>
    </nav>
    </div>
  );
}
